import { env } from 'settings/env';

export const getTurnstileKey = (): string => env.ENV_CLOUDFLARE_TURNSTILE_KEY;

export const getTurnstileLanguage = (): string =>
  env.ENV_PAGE_LANGUAGE || 'auto';

export function isTurnstileBypassAllowed(): boolean {
  const userAgent = window.navigator.userAgent;
  const envByPassList = env.ENV_CLOUDFLARE_TURNSTILE_USER_AGENT_BYPASS;
  const byPassList = envByPassList?.split(',').filter(Boolean) || [];

  return byPassList.some(byPassItem => userAgent.includes(byPassItem));
}
